import { useRef } from 'react';

/**
 * Contains a value which is stable under rerenders, unless `transparent` is set.
 * When the flag is set to true, then the internal value is set to `value` and this value
 * is returned.
 */
export function useTransparentRef<T>(value: T, transparent: boolean) {
    const ref = useRef(value);

    if (transparent) {
        ref.current = value;
    }

    return ref;
}
